module.exports = __webpack_public_path__ + "d6d99a4ca549b50e9e9580da568edfbd.png";